<template>
    <b-sidebar
     id="promotions-form-sidebar"
     :visible="isPromotionsFormSidebarActive"
     bg-variant="white"
     sidebar-class="sidebar-lg"
     shadow
     backdrop
     no-header
     right
     @shown="getData(promotionsData)"
     @hidden="resetForm"
     @change="(val) => $emit('update:is-promotions-form-sidebar-active', val)"
   >

   <template #default="{ hide }"> 
       <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
           <h5 class="mb-0">
               Promotions  Form
           </h5>
   
           <feather-icon
               class="ml-1 cursor-pointer"
               icon="XIcon"
               size="16"
               @click="hide"
           />
       </div>
       <validation-observer
         #default="{ handleSubmit }"
         ref="refFormObserver"
       >
         <b-form
           class="p-2"
           @submit.prevent="handleSubmit(onSubmit)"
           @reset.prevent="resetForm"
         >
            <b-tabs v-model="tabIndex">
                <b-tab title="Content">
                  <b-tabs content-class="mt-1" v-if="langs.length > 0" v-model="currentlangindex">
                    <b-tab v-for="(lang,key) in langs" :key="'tab-'+key"  :title="lang.name">
                      <validation-provider
                            #default="validationContext"
                            :name="'title_'+lang.code"
                            rules="required"
                          >
                            <b-form-group
                              label="Title"
                              :label-for="'title_'+lang.code"
                            >
                              <b-form-input
                                :id="'title_'+lang.code"
                                v-model="Data.title[lang.code]"
                                autofocus
                                :state="getValidationState(validationContext)"
                                trim
                                :placeholder="'Title ('+lang.code+')'"
                                @input="changeTitle(lang.code)"
                              />
          
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider
                      #default="validationContext"
                      :name="`sub_description_`+lang.code"
                      rules="required"
                    >
                      <b-form-group
                        label="Sub_Description"
                        :label-for="`sub_description_`+lang.code"
                      >
                        <b-form-input
                          :id="`sub_description_`+lang.code"
                          v-model="Data.sub_description[lang.code]"
                          autofocus
                          :state="getValidationState(validationContext)"
                          trim
                          :placeholder="'Sub Description ('+lang.code+')'"
                        />
          
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                    <validation-provider
                      #default="validationContext"
                      :name="`description_`+lang.code"
                      rules="min:0"
                    >
                      <b-form-group
                          label="Description"
                          :label-for="`description_`+lang.code"
                      >
                        
                          <quill-editor :options="editorOptions" v-model="Data.description[lang.code]" />
                          <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    </b-tab>
                  </b-tabs>
                  <hr>
            
                  <validation-provider
                    #default="validationContext"
                    name='category_id'
                    rules="required"
                  >
                    <b-form-group
                      label="Category"
                      label-for='category_id'
                    >
                      
                      <v-select
                              id='category_id'
                              v-model="Data.category_id"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                              label="title"
                              :reduce="(option) => option.id"
                              :options="catsData.map(g => ({title: g.title[langs[currentlangindex].code]?g.title[langs[currentlangindex].code]:'', id: g.id}))"
                      />
              
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
        
           <validation-provider
             #default="validationContext"
             name="price"
             rules="required"
           >
             <b-form-group
               label="price"
               label-for="price"
             >
               <b-form-input
                 id="price"
                 type="number"
                 v-model="Data.price"
                 autofocus
                 :state="getValidationState(validationContext)"
                 trim
                 placeholder="price"
               />
 
               <b-form-invalid-feedback>
                 {{ validationContext.errors[0] }}
               </b-form-invalid-feedback>
             </b-form-group>
           </validation-provider>
           
           <validation-provider
             #default="validationContext"
             name="IsActive"
             rules="min:0"
           >
             <b-form-group
               label="Is Active"
               label-for="IsActive"
             >
             
               <b-form-checkbox
               id="isactive"
                               checked="true"
                               class="custom-control-success"
                               v-model="Data.is_active"
                               switch
                 />
 
               <b-form-invalid-feedback>
                 {{ validationContext.errors[0] }}
               </b-form-invalid-feedback>
             </b-form-group>
           </validation-provider>
          
                </b-tab>

            </b-tabs>
           


           <div class="d-flex mt-2">
             <b-button
               v-ripple.400="'rgba(255, 255, 255, 0.15)'"
               variant="primary"
               class="mr-2"
               type="submit"
             >
               Submit
             </b-button>
             <b-button
               v-ripple.400="'rgba(186, 191, 199, 0.15)'"
               type="button"
               variant="outline-secondary"
               @click="hide"
             >
               Cancel
             </b-button>
           </div>
         </b-form>
         
         
       </validation-observer>
   </template>
   </b-sidebar>
</template>
<script>
import { $themeConfig } from '@themeConfig'
 import {
   BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback, BButton,BTabs, BTab
 } from 'bootstrap-vue'
 //upload
 import {
  BCard,BCardText,BMedia,BMediaAside,BMediaBody,BAvatar,BImg,BLink,BFormFile
 } from 'bootstrap-vue'
 import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'

 import { ValidationProvider, ValidationObserver } from 'vee-validate'
 import { ref,onUnmounted } from '@vue/composition-api'
 import { required, alphaNum, email, password,confirmed } from '@validations'
 import formValidation from '@core/comp-functions/forms/form-validation'
 import Ripple from 'vue-ripple-directive'
 import vSelect from 'vue-select'
 import countries from '@/@fake-db/data/other/countries'
 import store from '@/store'
 import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
 import { useToast } from 'vue-toastification/composition'
 import languagesStoreModule from '@/views/languages/languagesStoreModule'

import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { slugify } from '@/@fake-db/utils'

import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'
const sizeStyle = Quill.import('attributors/style/size')
sizeStyle.whitelist = ['6px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
Quill.register(sizeStyle, true)

export default {
   components: {
     BSidebar,
     BForm,
     BFormGroup,
     BFormInput,
     BFormTextarea,
     BFormCheckbox,
     BFormInvalidFeedback,
     BButton,
     BTabs, BTab,
     BCard,BCardText,BMedia,BMediaAside,BMediaBody,BAvatar,BImg,BLink,BFormFile,
     vSelect,
     quillEditor,
     // Form Validation
     ValidationProvider,
     ValidationObserver,
   },
   directives: {
     Ripple,
   },
   model: {
     prop: 'isPromotionsFormSidebarActive',
     event: 'update:is-promotions-form-sidebar-active',
   },
   props: {
     isPromotionsFormSidebarActive: {
       type: Boolean,
       required: true,
     },
    
     promotionsData: {
       type: Object,
       required: false,
     },
   },
    computed: {
      editorOptions (){
        return $themeConfig.snowOption
      }
    },
   setup(props, { emit }) {
    const {  appRef } = $themeConfig.app
       const toast = useToast()
       const tabIndex = ref(0);
       const catsData = ref([]);
       const featuredImage = ref({});
       const langs = ref([]);
       const currentlangindex = ref();
       const userStorage = JSON.parse(localStorage.getItem('userData'));
       const getLocalSite = JSON.parse(localStorage.getItem('site'))
       const LANGUAGES_STORE_MODULE_NAME = 'app-languages';
        if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule)
        onUnmounted(() => {
            if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME)
        });
       const blankData = {
           created_by:userStorage.id,
           created_at:null,
           category_id:null,
           title: {},
           price:'',
           sub_description:{},
           description:{},
           is_active:true,
           sites_id: getLocalSite.id,
       }
       const Data = ref(JSON.parse(JSON.stringify(blankData)))
       const resetData = () => {
           Data.value = JSON.parse(JSON.stringify(blankData))
       }
   
       const getData = (data)=>{
            tabIndex.value = 0;
            //refPreviewEl.value.src = require('@/assets/images/no-image.png');
           if(data){
               data.is_active = data.is_active?true:false;
               Data.value  = JSON.parse(JSON.stringify(data));
           }
       }
       store.dispatch('app-promotions/fetchCats', {})
      .then(response => {
        catsData.value = response.data.data
      })
      const getLangs = (fil)=>{
          store.dispatch('app-languages/fetchData', fil)
                 .then((res) => {
                     if(res.data.success){
                       langs.value = res.data.data;
                       
                     }
                     
                   
          });
       }
       let filter = {
        is_active:1,
            
       }
        getLangs(filter);
       const onSubmit = () => {
        let formData = new FormData();
            Data.value.is_active = Data.value.is_active?1:0;
            Data.value.path = '/var/www/html/uploadfiles/uploads/'+appRef+'/promotions/';
            Data.value.savepath = 'uploads/'+appRef+'/promotions/';
            for(const [key, value] of Object.entries(Data.value)) {
              if(key == 'title' || key == 'sub_description' || key == 'description'){
                formData.append(key, JSON.stringify(value)); 
              }
              else{
                formData.append(key, value);  
              }   
            
             
            
            }
           if(Data.value.id){
             
               store.dispatch('app-promotions/updateData', {formData:formData,data:Data.value})
               .then((res) => {
                   
                   if(res.data.success){
                   toast({
                       component: ToastificationContent,
                       position: 'top-right',
                       props: {
                       title: `Success`,
                       icon: 'BellIcon',
                       variant: 'success',
                       text: `${res.data.message}`,
                       },
                   });
                   emit('refetch-data')
                   emit('update:is-promotions-form-sidebar-active', false)
                   }else{
                   
                   toast({
                       component: ToastificationContent,
                       position: 'top-right',
                       props: {
                       title: `Error`,
                       icon: 'BellIcon',
                       variant: 'danger',
                       text: `${res.data.message}`,
                       },
                   });
               
                   
                   }
               
               })
           }else{
               store.dispatch('app-promotions/addData', {formData:formData})
               .then((res) => {
                   
                   if(res.data.success){
                   toast({
                       component: ToastificationContent,
                       position: 'top-right',
                       props: {
                       title: `Success`,
                       icon: 'BellIcon',
                       variant: 'success',
                       text: `${res.data.message}`,
                       },
                   });
                   emit('refetch-data')
                   emit('update:is-promotions-form-sidebar-active', false)
                   }else{
                   
                   toast({
                       component: ToastificationContent,
                       position: 'top-right',
                       props: {
                       title: `Error`,
                       icon: 'BellIcon',
                       variant: 'danger',
                       text: `${res.data.message}`,
                       },
                   });
               
                   
                   }
               
               })
           }

       }

       
        const {
       refFormObserver,
       getValidationState,
       resetForm,
     } = formValidation(resetData)
     //upload
     const refInputEl = ref(null)
      const refPreviewEl = ref(null)
     const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => { 
       
        refPreviewEl.value.src = base64 
     })
     const revomeImage = ()=>{
      Data.value.featuredImage = require('@/assets/images/no-image.png');
      Data.value.cover_image = '';
     }
     const changeTitle  = (lang) => {
      if(lang === 'en'){
          Data.value.slug =  slugify(Data.value.title[lang] )
        }
    }
     return {
       Data,
       onSubmit,

       catsData,
       refFormObserver,
       getValidationState,
       resetForm,
       getData,
       tabIndex,
       refInputEl,
       refPreviewEl,
       inputImageRenderer,
       revomeImage,
       changeTitle,
       langs,
       currentlangindex
       
     }
  
   }
   
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
</style>